export enum SmarticoRaffleDrawIds {
  HOURLY_DRAW = 449,
  GRAND_DRAW = 450,
}
